import { Injectable } from '@angular/core';
import { Employee } from './shared.model';
import { API_URL } from '../app.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {

  constructor(private http: HttpClient) { }

  list(keyword: string) : Observable<Array<Employee>> {
    return this.http.get<Array<Employee>>(`${API_URL}/Employees/${keyword}`);
  }
}
